import React, {useCallback,  useEffect, useRef, useState} from 'react';
import {debounce} from 'lodash';
import {objectReplaceReducer} from "./utils";

export function useToggle(initialValue = false) {
    const [value, setValue] = React.useState(initialValue);
    const toggle = React.useCallback(() => {
        setValue(v => !v);
    }, []);
    return [value, toggle];
}

// todo  works if we omit debouncedCallback from dependency?
export function useDebouncedEffect(callback, delay, deps = []) {

    const debouncedCallback = useCallback(debounce(callback,delay), [callback,delay]);

    useEffect(()=>{
            //console.log('Trying bounced effect: '+ _.now());
            debouncedCallback();
            return debouncedCallback.cancel;
        },
        [delay,  ...deps]
    );
}


// Sets up derived object that maintains the same object if the sources properties have the same value.
// Prevents uneeded (and sometimes troublesome) re-renders if passing the derived object as a property.
export function useDerivedObject(source, deriveFunc, initialValue)
{
    const ref = useRef(initialValue);
    ref.current = objectReplaceReducer(ref.current, deriveFunc(source));
    return ref.current;
}

// Access model contents via React Hook
// Create a model listener which sets the state
// todo attached model separately ?context ?window.model

export function useModel(model,itemType,setName,options) {

    options = options || {};
    const get = options.one ? 'getOne' : 'getSet';

    const myModel = model[itemType];
    const [data, setData] = useState(myModel[get](setName));

    useEffect(()=>{

        const listenerId = myModel.addListener(
            setName,
            ()=>setData(myModel[get](setName))
        );

        return ()=>
            myModel.removeListener(listenerId);

    }, [model,itemType,setName,  get,myModel]);

    return data;
}

